import React from 'react'
import PropTypes from 'prop-types'
import { inject, observer } from 'mobx-react'
import services from '../../components/services'
import { CONSTS, APIURL, PAGEURL } from '../../constants'
import { withRouter } from 'next/router'
import Link from 'next/link'
import { FiUsers } from 'react-icons/fi'
import { BsBuilding } from 'react-icons/bs'
import { Formik, Form, Field } from 'formik'
import FormikField from '../../components/forms/FormikField'
import * as Yup from 'yup'
import classNames from 'classnames'
import CountUp from 'react-countup'
import ActionPageLoader from '../../components/loaders/ActionPageLoader'
import DefaultLayout from '../../components/layouts/DefaultLayout'
import { Button } from '../theme/button/Button'

const isEmbedded = () => {
  if (typeof window !== 'undefined') {
    return window.location.href.match(/embed/)
  }
}

const baseUrl = () => {
  if (isEmbedded()) {
    return '/embed/roi-calculator/'
  } else {
    return '/roi-calculator/'
  }
}

const notifyParent = () => {
  if (window.parent) {
    window.parent.postMessage(
      {
        calcHeight: document.body.scrollHeight + 'px'
      },
      '*'
    )
  }
}

const question_lookup = {
  market: 1,
  num_staff: 2,
  health_insurance: 3,
  succession_link_interest: 4,
  annual_compliance: 5,
  lead_generation: 6,
  supplies_spending: 7,
  cyber_insurance: 8,
  software_services: 9
}

@inject('store')
@observer
class RoiCalculator extends React.Component {
  static propTypes = {
    active_section: PropTypes.string,
    active_tab: PropTypes.string
  }

  constructor(props) {
    super(props)
    this.state = {
      question_data: {},
      questions: [],
      current_question: 0,
      current_selection: null,
      next_disabled: false,
      savings: null,
      tier_needed: 1,
      roi_uuid: null,
      results_page: false,
      mounting: true,
      current_selections: null,
      is_advisor: true,
      old_savings: 0
    }
  }

  makeSelectionMultiple(e, value) {
    const { question_data, current_question } = this.state
    if (e) {
      const current_selections = question_data[current_question].value || []
      if (e.target.classList.contains('selected')) {
        e.target.classList.remove('selected')
        const index = current_selections.indexOf(value)
        if (index > -1) {
          current_selections.splice(index, 1)
        }
      } else {
        e.target.classList.add('selected')
        current_selections.push(value)
        question_data[current_question].value = current_selections
      }
      this.setState({
        current_selections: current_selections,
        question_data: question_data
      })
    } else if (value) {
      const current_selections = question_data[current_question].value || []
      for (const index in value) {
        const option = document.getElementById(String(value[index]))
        option.classList.add('selected')
      }
      this.setState({ current_selections: current_selections })
    }
  }

  makeSelection(e, value) {
    if (e) {
      e.target.parentNode.childNodes.forEach((child) => {
        child.classList.remove('selected')
      })
      e.target.classList.add('selected')
      this.setState({ next_disabled: false, current_selection: value })
    } else if (value || value === false) {
      const option = document.getElementById(String(value))
      option.classList.add('selected')
      this.setState({ next_disabled: false, current_selection: value })
    }
  }

  nextQuestion = async (values) => {
    try {
      const {
        current_selection,
        current_selections,
        question_data,
        questions,
        current_question,
        roi_uuid
      } = this.state
      if (current_question === 0) {
        const result = await services.post_v2(APIURL.API_ROI_CALCULATOR, values)
        if (result.response.roi_uuid) {
          window.localStorage.setItem('roi_uuid', result.response.roi_uuid)
          const q_data = await this.clearQuestionValues()
          this.setState(
            {
              roi_uuid: result.response.roi_uuid,
              question_data: q_data,
              savings: null
            },
            () => {
              this.props.router.push(
                baseUrl() + '?question=' + (current_question + 1)
              )
            }
          )
        }
      } else {
        let save_values = current_selection
        if (question_data[current_question].multiple_select) {
          save_values = current_selections
        }
        const roi_calc = await services.put_v2(APIURL.API_ROI_CALCULATOR, {
          column: question_data[current_question].column,
          value: save_values,
          roi_uuid: roi_uuid,
          question_number: current_question
        })
        const savings = roi_calc.savings ? roi_calc.savings[0] : null
        const tier_needed = roi_calc.savings ? roi_calc.savings[1] : 1
        const updated_question_data = question_data
        updated_question_data[current_question]['value'] = save_values
        this.setState(
          {
            old_savings: this.state.savings,
            savings: savings,
            tier_needed: tier_needed,
            question_data: updated_question_data,
            current_selection: null,
            questions: questions
          },
          () => {
            if (current_question === questions.length - 1) {
              this.props.router.push(
                baseUrl() + 'email-form/' + '?results=' + roi_uuid
              )
              this.setState({ results_page: true })
            } else {
              this.props.router.push(
                baseUrl() + '?question=' + (current_question + 1)
              )
            }
          }
        )
      }
    } catch (e) {
      console.error(e)
    }
  }

  buildQuestions = (prevData = null) => {
    try {
      const { userData } = this.props.store.sessionData
      const questions = []
      const MARKETS = []
      const NUM_STAFF = []
      const SL_INTERESTS = []
      const SUPPLY_SPENDING = []
      const SOFTWARE_SERVICES = []
      const LEAD_GENERATION = []
      for (const key in CONSTS.MARKETS) {
        MARKETS.push(
          <div
            key={key}
            id={key}
            className="calc-options with-hover"
            onClick={(e) => {
              this.makeSelection(e, key)
            }}
          >
            {CONSTS.MARKETS[key]}
          </div>
        )
      }
      for (const key in CONSTS.NUM_STAFF) {
        NUM_STAFF.push(
          <div
            key={key}
            id={key}
            className="calc-options with-hover"
            onClick={(e) => {
              this.makeSelection(e, key)
            }}
          >
            {CONSTS.NUM_STAFF[key]}
          </div>
        )
      }
      for (const key in CONSTS.SL_INTERESTS) {
        SL_INTERESTS.push(
          <div
            key={key}
            id={key}
            className="calc-options with-hover"
            onClick={(e) => {
              this.makeSelection(e, key)
            }}
          >
            {CONSTS.SL_INTERESTS[key]}
          </div>
        )
      }
      for (const key in CONSTS.LEAD_GENERATION) {
        LEAD_GENERATION.push(
          <div
            key={key}
            id={key}
            className="calc-options with-hover"
            onClick={(e) => {
              this.makeSelection(e, key)
            }}
          >
            {CONSTS.LEAD_GENERATION[key]}
          </div>
        )
      }
      for (const key in CONSTS.SUPPLY_SPENDING) {
        SUPPLY_SPENDING.push(
          <div
            key={key}
            id={key}
            className="calc-options with-hover"
            onClick={(e) => {
              this.makeSelection(e, key)
            }}
          >
            {CONSTS.SUPPLY_SPENDING[key]}
          </div>
        )
      }
      for (const key in CONSTS.SOFTWARE_SERVICES) {
        SOFTWARE_SERVICES.push(
          <div
            key={key}
            id={key}
            className="calc-options with-hover"
            onClick={(e) => {
              this.makeSelectionMultiple(e, key)
            }}
          >
            {CONSTS.SOFTWARE_SERVICES[key]}
          </div>
        )
      }

      const QUESTION_DATA = {
        1: {
          column: 'market',
          question_title: 'My business is...',
          options: MARKETS,
          icon: <BsBuilding className="fa-5x" />,
          value: prevData && prevData[1] ? prevData[1].value : null
        },
        2: {
          column: 'num_staff',
          question_title: 'How many people are on your team?',
          options: NUM_STAFF,
          icon: <FiUsers className="fa-5x" />,
          value: prevData && prevData[2] ? prevData[2].value : null
        },
        3: {
          column: 'health_insurance',
          question_title:
            'Do you (or would you like to) provide health insurance to your employees?',
          options: [
            <div
              key={'health-insurance-true'}
              value={true}
              id={'true'}
              className="calc-options with-hover"
              onClick={(e) => {
                this.makeSelection(e, true)
              }}
            >
              Yes
            </div>,
            <div
              key={'health-insurance-false'}
              value={false}
              id={'false'}
              className="calc-options with-hover"
              onClick={(e) => {
                this.makeSelection(e, false)
              }}
            >
              No
            </div>
          ],
          icon: (
            <img
              className="question-icon"
              src="/assets/images/roi-calculator/RoiHealthInsurance.png"
            />
          ),
          value: prevData && prevData[3] ? prevData[3].value : null
        },
        4: {
          column: 'succession_link_interest',
          question_title:
            'Would you consider buying, selling, or merging businesses?',
          options: SL_INTERESTS,
          icon: (
            <img
              className="question-icon"
              src="/assets/images/roi-calculator/RoiBuyingBusiness.png "
            />
          ),
          value: prevData && prevData[4] ? prevData[4].value : null
        },
        5: {
          column: 'annual_compliance',
          question_title:
            'Do you spend $6,000 or more on your annual compliance requirements?',
          options: [
            <div
              key={'annual-compliance-true'}
              value={true}
              id={'true'}
              className="calc-options with-hover"
              onClick={(e) => {
                this.makeSelection(e, true)
              }}
            >
              Yes
            </div>,
            <div
              key={'annual-compliance-false'}
              value={false}
              id={'false'}
              className="calc-options with-hover"
              onClick={(e) => {
                this.makeSelection(e, false)
              }}
            >
              No
            </div>
          ],
          icon: (
            <img
              className="question-icon"
              src="/assets/images/roi-calculator/RoiCompliance.png"
            />
          ),
          value: prevData && prevData[5] ? prevData[5].value : null
        },
        6: {
          column: 'lead_generation',
          question_title:
            'Would you be interested in investing to improve lead generation?',
          options: [
            <div
              key={'lead-gen-true'}
              value={true}
              id={'true'}
              className="calc-options with-hover"
              onClick={(e) => {
                this.makeSelection(e, true)
              }}
            >
              Yes
            </div>,
            <div
              key={'lead-gen-false'}
              value={false}
              id={'false'}
              className="calc-options with-hover"
              onClick={(e) => {
                this.makeSelection(e, false)
              }}
            >
              No
            </div>
          ],
          icon: (
            <img
              className="question-icon"
              src="/assets/images/roi-calculator/RoiLeadGeneration.png"
            />
          ),
          value: prevData && prevData[6] ? prevData[6].value : null
        },
        7: {
          column: 'supplies_spending',
          question_title: 'How much do you spend annually on office supplies?',
          options: SUPPLY_SPENDING,
          icon: (
            <img
              className="question-icon"
              src="/assets/images/roi-calculator/RoiTech.png"
            />
          ),
          value: prevData && prevData[7] ? prevData[7].value : null
        },
        8: {
          column: 'cyber_insurance',
          question_title:
            'Would you like cyber insurance to help protect your businesses?',
          options: [
            <div
              key={'cyber-insurance-true'}
              value={true}
              id={'true'}
              className="calc-options with-hover"
              onClick={(e) => {
                this.makeSelection(e, true)
              }}
            >
              Yes
            </div>,
            <div
              key={'cyber-insurance-false'}
              value={false}
              id={'false'}
              className="calc-options with-hover"
              onClick={(e) => {
                this.makeSelection(e, false)
              }}
            >
              No
            </div>
          ],
          icon: (
            <img
              className="question-icon"
              src="/assets/images/roi-calculator/RoiCyberSecurity.png"
            />
          ),
          value: prevData && prevData[8] ? prevData[8].value : null
        }
      }

      // if (this.state.is_advisor) {
      QUESTION_DATA[9] = {
        column: 'software_services',
        question_title: 'Select all software services you may consider using',
        options: SOFTWARE_SERVICES,
        icon: (
          <img
            className="question-icon"
            src="/assets/images/roi-calculator/RoiSoftware.png"
          />
        ),
        multiple_select: true,
        value: prevData && prevData[8] ? prevData[8].value : null
      }
      // }

      questions.push(
        <div>
          <img
            className="roi-logo"
            src="https://caexcontent.s3-us-west-2.amazonaws.com/Roi+Calculator/RoiCalculatorLogo.png"
          />
          <div className="question-title">
            Let&apos;s add your savings for you and your business. Ready to go?
          </div>
          <Formik
            initialValues={{
              first_name: userData.first_name || '',
              last_name: userData.last_name || ''
            }}
            validationSchema={Yup.object({
              first_name: Yup.string().required('Required'),
              last_name: Yup.string().required('Required')
            })}
            onSubmit={async (values, { setSubmitting }) => {
              await this.nextQuestion(values)
            }}
          >
            <Form>
              <div className="calc-options-container">
                <FormikField name="first_name" required={true}>
                  <Field
                    className="calc-options"
                    placeholder="First Name"
                    name="first_name"
                    type="text"
                  />
                </FormikField>
                <FormikField name="last_name" required={true}>
                  <Field
                    className="calc-options no-hover"
                    placeholder="Last Name"
                    name="last_name"
                    type="text"
                  />
                </FormikField>
              </div>
              <Button className="continue-calc" type="submit">
                Start Saving
              </Button>
            </Form>
          </Formik>
        </div>
      )
      for (const q in QUESTION_DATA) {
        questions.push(
          <div>
            <div className="question-title">
              {QUESTION_DATA[q].question_title}
            </div>
            <div className="calc-icon-container" column={q}>
              {QUESTION_DATA[q].icon}
            </div>
            <div className="calc-options-container">
              {QUESTION_DATA[q].options}
            </div>
          </div>
        )
      }
      this.setState({ questions: questions, question_data: QUESTION_DATA })
      return QUESTION_DATA
    } catch (e) {
      console.error(e)
    }
  }

  componentDidMount = async () => {
    try {
      this.props.store.updateNav(true, false)
      await this.buildQuestions()
      let q_data = {}
      let roi_uuid = this.props.router.query.results
      let results_page = false
      let has_value = false
      let current_selection = null
      let current_selections = null
      if (roi_uuid) {
        window.localStorage.setItem('roi_uuid', roi_uuid)
        results_page = true
      } else {
        roi_uuid = window.localStorage.getItem('roi_uuid')
      }
      if (roi_uuid) {
        const roi_calc = await services.get_v2(APIURL.API_ROI_CALCULATOR, {
          params: {
            roi_uuid: roi_uuid
          }
        })
        const savings = roi_calc.savings ? roi_calc.savings[0] : null
        const tier_needed = roi_calc.savings ? roi_calc.savings[1] : 1
        const current_question = parseInt(this.props.question)
        if (current_question === 0) {
          q_data = await this.clearQuestionValues(roi_calc)
        } else {
          q_data = await this.setQuestionValues(roi_calc)
          if (
            q_data[current_question] &&
            (q_data[current_question].value ||
              q_data[current_question].value === false)
          ) {
            has_value = true
          }
        }
        if (
          q_data[current_question] &&
          q_data[current_question].multiple_select
        ) {
          current_selections = q_data[current_question].value
        } else if (q_data[current_question]) {
          current_selection = q_data[current_question].value
        }
        this.setState(
          {
            roi_uuid: roi_uuid,
            current_question: current_question,
            savings: savings,
            tier_needed: tier_needed,
            results_page: results_page,
            question_data: q_data,
            current_selection: current_selection,
            next_disabled: !has_value,
            mounting: false
          },
          () => {
            if (q_data[current_question]) {
              if (q_data[current_question].multiple_select) {
                this.makeSelectionMultiple(null, current_selections)
              } else {
                this.makeSelection(null, current_selection)
              }
            }
          }
        )
      } else {
        this.setState({ mounting: false }, () => {
          if (parseInt(this.props.question) !== 0) {
            this.props.router.push(baseUrl() + '?question=0/')
          }
        })
      }
    } catch (e) {
      console.error(e)
    }
    // Notify parent if this is an embedded iframe
    if (window.parent) {
      window.addEventListener('resize', () => {
        notifyParent()
      })
    }
  }

  componentDidUpdate = async () => {
    try {
      const {
        questions,
        current_question,
        results_page,
        question_data,
        mounting
      } = this.state
      if (!mounting) {
        const url_q_num = parseInt(this.props.question)
        let disable_next = true
        if (url_q_num !== current_question) {
          if (
            (question_data[url_q_num] &&
              question_data[url_q_num].multiple_select) ||
            (question_data[url_q_num] &&
              (question_data[url_q_num].value ||
                question_data[url_q_num].value === false))
          ) {
            disable_next = false
          }
          this.setState(
            {
              current_question: url_q_num,
              results_page: current_question === questions.length,
              next_disabled: disable_next
            },
            () => {
              if (question_data[url_q_num]) {
                if (question_data[url_q_num].multiple_select) {
                  this.makeSelectionMultiple(
                    null,
                    question_data[url_q_num].value
                  )
                } else {
                  this.makeSelection(null, question_data[url_q_num].value)
                }
              }
            }
          )
        } else if (results_page !== (current_question === questions.length)) {
          this.setState({ results_page: current_question === questions.length })
        } else if (
          question_data[question_lookup['market']].value &&
          question_data[question_lookup['market']].value !== 'advisor' &&
          this.state.is_advisor
        ) {
          this.setState({ is_advisor: false }, async () => {
            this.buildQuestions(this.state.question_data)
          })
        } else if (
          question_data[question_lookup['market']].value &&
          question_data[question_lookup['market']].value === 'advisor' &&
          !this.state.is_advisor
        ) {
          this.setState({ is_advisor: true }, async () => {
            this.buildQuestions(this.state.question_data)
          })
        }
      }
    } catch (e) {
      console.error(e)
    }
    notifyParent()
  }

  setQuestionValues = async (roi_calc) => {
    try {
      const q_data = this.state.question_data
      for (const value in roi_calc) {
        if (question_lookup[value] && q_data[question_lookup[value]]) {
          q_data[question_lookup[value]].value = roi_calc[value]
        }
      }
      return q_data
    } catch (e) {
      console.error(e)
    }
  }

  clearQuestionValues = async () => {
    const q_data = this.state.question_data
    for (const q in q_data) {
      q_data[q].value = null
    }
    return q_data
  }

  progessClick = async (question) => {
    if (
      this.state.question_data[question].value ||
      this.state.question_data[question].value === false
    ) {
      this.props.router.push(baseUrl() + `?question=${question}/`)
    }
  }

  componentWillUnmount() {
    this.props.store.updateNav(true, true)
  }

  render() {
    let join_text = ''
    let additional_text = ''
    let join_link = ''
    let display_join_btn = false
    // const pricing_tier = this.props.store.userTier()
    // const { is_registered } = this.props.store.getMembershipStatus()
    // Registration is turned off so we'll turn this off too
    /*
    if (is_registered) { //  && pricing_tier < this.state.tier_needed) {
      additional_text = ''
      join_text = 'UPGRADE NOW'
      join_link = PAGEURL.SIGNUP_REGISTER + '?plan=' + this.state.tier_needed
    } else if (is_registered) { //  && pricing_tier >= this.state.tier_needed) {
      additional_text = ''
      display_join_btn = false
    }
    */
    let results_text =
      'Take a look at your potential ROI as a member of Chalice Network:'
    let joinButton = null
    if (display_join_btn) {
      if (isEmbedded()) {
        // joinButton = <Link href={join_link}><a className="mt-xl action-btn-blue speak-to-rep-btn mb-none">{join_text}</a></Link>
        joinButton = (
          <a
            className="mt-xl action-btn-blue speak-to-rep-btn mb-none"
            href={join_link}
          >
            {join_text}
          </a>
        )
      } else {
        joinButton = (
          <a
            className="mt-xl action-btn-blue speak-to-rep-btn mb-none"
            href={join_link}
          >
            {join_text}
          </a>
        )
      }
    }

    if (this.state.roi_uuid === null && this.state.current_question !== 0) {
      return <ActionPageLoader />
    }
    return (
      <div>
        <div
          className={
            'roi-calc ' + classNames({ 'display-none': this.state.mounting })
          }
        >
          <div className="container-fluid content-padded roi-calc-content">
            <div className="col-sm-12 col-md-12 bottom-marketplace profile-content">
              {this.state.questions[this.state.current_question]}
              {this.state.results_page && (
                <div>
                  <div className="intro-title thank-you">Thank You!</div>
                  <div className="question-title thank-you">{results_text}</div>
                  <div className="savings-line">
                    <div className="savings-decriptions">
                      Potential Savings with Chalice Membership:
                    </div>
                    <div className="savings-amount">
                      <CountUp
                        start={0}
                        end={this.state.savings}
                        duration={1}
                        separator=","
                        decimals={2}
                        decimal="."
                        prefix="$"
                        className="roi-savings"
                      />
                    </div>
                  </div>
                  <div className="savings-line">
                    <div className="savings-decriptions">
                      Annual Chalice Membership:
                    </div>
                    <div className="savings-amount">
                      <CountUp
                        start={0}
                        end={
                          CONSTS.CHALICE_YEARLY_MEMBERSHIP_AMOUNT[
                            this.state.tier_needed
                          ]
                        }
                        duration={1}
                        separator=","
                        decimals={2}
                        decimal="."
                        prefix="-$"
                      />
                    </div>
                  </div>
                  <div className="gold-border"></div>
                  <div className="savings-line total-savings">
                    <div className="savings-decriptions">Your Total ROI:</div>
                    <div className="savings-amount">
                      <CountUp
                        start={0}
                        end={
                          this.state.savings -
                          CONSTS.CHALICE_YEARLY_MEMBERSHIP_AMOUNT[
                            this.state.tier_needed
                          ]
                        }
                        duration={1}
                        separator=","
                        decimals={2}
                        decimal="."
                        prefix="$"
                      />
                    </div>
                  </div>
                </div>
              )}
              {this.state.current_question !== 0 && !this.state.results_page && (
                <div>
                  <Button
                    disabled={this.state.next_disabled}
                    className="continue-calc"
                    onClick={() => {
                      this.nextQuestion()
                    }}
                  >
                    Next
                  </Button>
                </div>
              )}
              {!this.state.results_page && this.state.current_question !== 0 && (
                <div className="progess-container-calc">
                  <ul className="progressbar-calc">
                    <li
                      onClick={() => {
                        this.progessClick(1)
                      }}
                      className={classNames({
                        'active-current': this.state.current_question === 1,
                        active: this.state.current_question >= 1,
                        clickable:
                          this.state.question_data[1] &&
                          (this.state.question_data[1].value ||
                            this.state.question_data[1].value === false)
                      })}
                    ></li>
                    <li
                      onClick={() => {
                        this.progessClick(2)
                      }}
                      className={classNames({
                        'active-current': this.state.current_question === 2,
                        active: this.state.current_question >= 2,
                        clickable:
                          this.state.question_data[2] &&
                          (this.state.question_data[2].value ||
                            this.state.question_data[2].value === false)
                      })}
                    ></li>
                    <li
                      onClick={() => {
                        this.progessClick(3)
                      }}
                      className={classNames({
                        'active-current': this.state.current_question === 3,
                        active: this.state.current_question >= 3,
                        clickable:
                          this.state.question_data[3] &&
                          (this.state.question_data[3].value ||
                            this.state.question_data[3].value === false)
                      })}
                    ></li>
                    <li
                      onClick={() => {
                        this.progessClick(4)
                      }}
                      className={classNames({
                        'active-current': this.state.current_question === 4,
                        active: this.state.current_question >= 4,
                        clickable:
                          this.state.question_data[4] &&
                          (this.state.question_data[4].value ||
                            this.state.question_data[4].value === false)
                      })}
                    ></li>
                    <li
                      onClick={() => {
                        this.progessClick(5)
                      }}
                      className={classNames({
                        'active-current': this.state.current_question === 5,
                        active: this.state.current_question >= 5,
                        clickable:
                          this.state.question_data[5] &&
                          (this.state.question_data[5].value ||
                            this.state.question_data[5].value === false)
                      })}
                    ></li>
                    <li
                      onClick={() => {
                        this.progessClick(6)
                      }}
                      className={classNames({
                        'active-current': this.state.current_question === 6,
                        active: this.state.current_question >= 6,
                        clickable:
                          this.state.question_data[6] &&
                          (this.state.question_data[6].value ||
                            this.state.question_data[6].value === false)
                      })}
                    ></li>
                    <li
                      onClick={() => {
                        this.progessClick(7)
                      }}
                      className={classNames({
                        'active-current': this.state.current_question === 7,
                        active: this.state.current_question >= 7,
                        clickable:
                          this.state.question_data[7] &&
                          (this.state.question_data[7].value ||
                            this.state.question_data[7].value === false)
                      })}
                    ></li>
                    <li
                      onClick={() => {
                        this.progessClick(8)
                      }}
                      className={classNames({
                        'active-current': this.state.current_question === 8,
                        active: this.state.current_question >= 8,
                        clickable:
                          this.state.question_data[8] &&
                          (this.state.question_data[8].value ||
                            this.state.question_data[8].value === false)
                      })}
                    ></li>
                    {this.state.is_advisor && (
                      <li
                        onClick={() => {
                          this.progessClick(9)
                        }}
                        className={classNames({
                          'active-current': this.state.current_question === 9,
                          active: this.state.current_question >= 9,
                          clickable:
                            this.state.question_data[9] &&
                            (this.state.question_data[9].value ||
                              this.state.question_data[9].value === false)
                        })}
                      ></li>
                    )}
                  </ul>
                </div>
              )}
            </div>
          </div>
          {this.state.savings !== null &&
            !this.state.results_page &&
            this.state.current_question !== 0 &&
            this.props.store.isAuthenticated() && (
              <div className="roi-calc-footer">
                <CountUp
                  start={this.state.old_savings}
                  end={this.state.savings}
                  duration={1}
                  separator=","
                  decimals={2}
                  decimal="."
                  prefix="$"
                  className="roi-savings"
                />
                <div className="roi-savings-text">
                  Your potential savings with a Chalice Membership
                </div>
              </div>
            )}
          {this.state.results_page && (
            <div className="roi-results-footer">
              {/*
              <div className="money-back">
                <div className='money-back-wrapper'>
                  <div>
                    Not Ready? No worries.  Sign up now for a 30 day free trial!
                  </div>
                </div>
                { joinButton }
              </div>
              */}
              <div className="speak-to-rep">Want to learn more?</div>
              <button
                className="action-btn-blue continue-calc speak-to-rep-btn"
                onClick={() => {
                  window.open(
                    'https://calendly.com/whitneykendrick/30min',
                    '_blank'
                  )
                }}
              >
                Speak to a Rep
              </button>
            </div>
          )}
        </div>
      </div>
    )
  }
}

RoiCalculator.propTypes = {
  router: PropTypes.object,
  store: PropTypes.object,
  question: PropTypes.string
}

export default withRouter(RoiCalculator)
